import styled from "styled-components";


export const UnderConstructionStyled = styled.div`
    width: 100%;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: space-between;
    gap: 2rem;
    .icon{
        display: flex;
        justify-content: center;
        font-size: 3rem;
        animation: shake 0.5s infinite;
        color: #5fbec5;
    }
    @keyframes shake {
        0% { transform: rotate(0deg); }
        25% { transform: rotate(5deg); }
        50% { transform: rotate(-5deg); }
        75% { transform: rotate(5deg); }
        100% { transform: rotate(0deg); }
    }
    .BoxContainer{
        display: flex;
        flex-direction: column;
        gap: 1rem;
        .info, .form {
            width: 100%;
        }

        .info {
            display: flex;
            flex-direction: column;
            gap: 2rem;
            justify-content: center;
            align-items: center;
            border-bottom: 1px solid #5fbec5;
            padding-bottom: 1.5rem;


            h1 {
                font-size: 2rem;
                text-align: center;
                
            }

            p {
                text-align: center;
                font-size: 0.9rem;
                font-weight: 500;
            }
        }
        .form{
            display: flex;
            flex-direction: column;
            gap: 1rem;
            align-items: center;    
            p{
                text-align: center;
                font-size: 2rem;
                font-weight: 600;
            }
            .formContainer{
                form{
                    display: flex;
                    flex-direction: column;
                    gap: 1rem;
                    input, textarea{
                        border: 2px solid #5fbec5;
                        border-radius: 0.625rem;
                        background: none;
                        color: #fff; 
                        outline: none;
                        padding: 0.5rem 0.75rem;
                    }
                    
                }
            }
        }
    }
    @media only screen and (min-width: 992px) {
        .BoxContainer{
            flex-direction: row;
            .info, .form {
                width: 50%;
            }
            .info{
                border-right: 1px solid #5fbec5;
                border-bottom: none;

                h1 {
                    font-size: 4rem;
                }

                p {
                    font-size: 1.2rem;
                    font-weight: 500;
                }

            }
        }
    }
`